import React from 'react';
import { CalculatorIcon, DocumentTextIcon } from '@heroicons/react/24/outline';

interface EstimateTypeBadgeProps {
  type: 'quick' | 'detailed';
}

const EstimateTypeBadge: React.FC<EstimateTypeBadgeProps> = ({ type }) => {
  const styles = {
    quick: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      icon: <CalculatorIcon className="h-4 w-4" />,
      label: 'Rapide'
    },
    detailed: {
      bg: 'bg-orange-100',
      text: 'text-orange-800',
      icon: <DocumentTextIcon className="h-4 w-4" />,
      label: 'Détaillée'
    }
  };

  const { bg, text, icon, label } = styles[type];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bg} ${text}`}>
      {icon}
      <span className="ml-1">{label}</span>
    </span>
  );
};

export default EstimateTypeBadge;